import { Component, ElementRef, EventEmitter, inject, Output, ViewChild, type OnInit } from '@angular/core';
import { SimplebarAngularModule } from 'simplebar-angular'
import { LogoBoxComponent } from "@components/logo-box.component";
import { MENU_ITEMS_DATO_MUFTI, MENU_ITEMS_PEBGGUNA, MENU_ITEMS_SUPERADMIN, MENU_ITEMS_PEGAWAI_LAPANGAN, type MenuItemType, MENU_ITEMS_PEGAWAI_PENGESAH, MENU_ITEMS_URUSETIA, MENU_ITEMS_MAIS, MENU_ITEMS_URUSETIA_BCS } from '@common/menu-meta';
import { basePath } from '@common/constants';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { findAllParent, findMenuItem } from '@core/helper/utils';
import { NgbCollapseModule, type NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { changesidebarsize } from '@/store/layout/layout-action';
import { getSidebarsize } from '@/store/layout/layout-selector';
import { StorageService } from '@core/services/storage.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [SimplebarAngularModule, CommonModule, NgbCollapseModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styles: ``
})
export class SidebarComponent implements OnInit {
  @ViewChild('sidenav') sidenav!: ElementRef;
  public http = inject(HttpClient)
  
  baseUrl = environment.baseUrl

  divWidth: number = 0;
  menuItems: MenuItemType[] = [];
  activeMenuItems: string[] = [];
  @Output() mobileMenuClose = new EventEmitter();
  private resizeObserver!: ResizeObserver;
  router = inject(Router);
  trimmedURL = this.router.url?.replaceAll(
    basePath !== '' ? basePath + '/' : '',
    '/',
  );

  store = inject(Store);
  currentWidth: any;
  user: any;
  userManualLink = '';
  constructor(
    private storage: StorageService
  ) {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.trimmedURL = this.router.url?.replaceAll(
          basePath !== '' ? basePath + '/' : '',
          '/',
        );
        this._activateMenu();
        setTimeout(() => {
          this.scrollToActive();
        }, 200);
      }
    });
  }

  ngOnInit(): void {
    this.initMenu();

  }

  initMenu(): void {
    this.user = this.storage.get('auth.user')
    if (this.user.role == "1") { //Pengguna
      this.menuItems = MENU_ITEMS_PEBGGUNA;
      this.userManualLink = "../../assets/manual/Pemohon.pdf"
    } else if (this.user.role == "6") { //Pegawai ICT | Super Admin
      this.menuItems = MENU_ITEMS_SUPERADMIN;
      this.userManualLink = "../../assets/manual/Superadmin.pdf"
    }
    else if (this.user.role == "5") { //DATO MUFTI
      this.menuItems = MENU_ITEMS_DATO_MUFTI;
      this.userManualLink = "../../assets/manual/Dato_Mufti.pdf"
    }
    else if (this.user.role == "3" || this.user.role == "9") { //PEGAWAI LAPANGAN and PEGAWAI LAPANGAN PERSATUAN
      this.menuItems = MENU_ITEMS_PEGAWAI_LAPANGAN;
      this.userManualLink = "../../assets/manual/Pegawai_Lapangan.pdf"
    }
    else if (this.user.role == "4") { //PEGAWAI PENGESAH
      this.menuItems = MENU_ITEMS_PEGAWAI_PENGESAH;
      this.userManualLink = "../../assets/manual/Pegawai_Pengesah.pdf"
    }
    else if (this.user.role == "2") { //Urusetia
      this.menuItems = MENU_ITEMS_URUSETIA;
      this.userManualLink = "../../assets/manual/Urusetia.pdf"
    } else if (this.user.role == "7") { //Mais
      this.menuItems = MENU_ITEMS_MAIS;
      this.userManualLink = "../../assets/manual/MAIS.pdf"
    } else if (this.user.role == "8") { //Urusetia BCS
      this.menuItems = MENU_ITEMS_URUSETIA_BCS;
      this.userManualLink = "../../assets/manual/Urusetia_BCS.pdf"
    }


    this.getCounterArahPremis();
    this.getCounterArahRumah();
    this.getCounterAzimut();
    if(this.user.role != "1"){
      this.getCounterLawatan();
    }
  }


  getCounterArahPremis() {
     this.user = this.storage.get('auth.user')
     let profile = ""
    if(this.user.role == '3'){
      profile = 'Komersil'
    }else if(this.user.role == '9'){
      profile = 'Swasta'
    }else{
      profile = 'Komersil'
    }
    this.http.get(this.baseUrl+`api/admin/arah-kiblat/senaraitugasan?page=1&search=&is_draf=0&profile=${profile}`).subscribe((res:any)=>{
      console.log(res);
      

    for (let index = 0; index < this.menuItems.length; index++) {
      const element = this.menuItems[index];
      if (element.key == "arah") {
        if (element.children) {
          for (let index2 = 0; index2 < element.children!.length; index2++) {
            const children = element.children![index2];
            if (children.key == "arah-task-list") {
              element.children![index2].badge = {
                text: res.data.total,
                variant: "success",
              }
            }
          }
        }
      }
    }
    })
  }

   getCounterArahRumah() {
    this.http.get(this.baseUrl+`api/admin/arah-kiblat/senaraitugasan?page=1&search=&is_draf=0&profile=Swasta`).subscribe((res:any)=>{
      console.log(res);
      

    for (let index = 0; index < this.menuItems.length; index++) {
      const element = this.menuItems[index];
      if (element.key == "arah") {
        if (element.children) {
          for (let index2 = 0; index2 < element.children!.length; index2++) {
            const children = element.children![index2];
            if (children.key == "arah-rumah-task-list") {
              element.children![index2].badge = {
                text: res.data.total,
                variant: "success",
              }
            }
          }
        }
      }
    }
    })
  }

  getCounterAzimut() {
    this.http.get(this.baseUrl+`api/admin/azimut/count-new-permohonan`).subscribe((res:any)=>{
      for (let index = 0; index < this.menuItems.length; index++) {
        const element = this.menuItems[index];
        if (element.key == "azimut") {
          if (element.children) {
            for (let index2 = 0; index2 < element.children!.length; index2++) {
              const children = element.children![index2];
              if (children.key == "azimuth-task-list") {
                element.children![index2].badge = {
                  text: res,
                  variant: "success",
                }
              }
            }
          }
        }
      }
    })
  }


  
  getCounterLawatan() {
    this.http.get(this.baseUrl+`api/pemohon/lawatan-balai-cerap/count-new-permohonan?page=&name=&bengkel_pengenalan_teleskop=&date_from=&date_to=&status=Sedang diproses oleh Urusetia`).subscribe((res:any)=>{
      for (let index = 0; index < this.menuItems.length; index++) {
        const element = this.menuItems[index];
        if (element.key == "permohonan-lawatan") {
          if (element.children) {
            for (let index2 = 0; index2 < element.children!.length; index2++) {
              const children = element.children![index2];
              if (children.key == "list-task") {
                element.children![index2].badge = {
                  text: res,
                  variant: "success",
                }
              }
            }
          }
        }
      }
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this._activateMenu();
      this._activateMenu();
    });
    setTimeout(() => {
      this.scrollToActive();
    }, 200);
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === this.sidenav.nativeElement) {
          this.currentWidth = entry.contentRect.width
          this.divWidth = entry.contentRect.width;
          console.log(this.divWidth);

        }
      }
    });
    this.resizeObserver.observe(this.sidenav.nativeElement); // Start observing
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect(); // Cleanup the observer when the component is destroyed
  }


  // getDivWidth() {
  //   const width = this.sidenav.nativeElement.offsetWidth; // Includes padding and border
  //   console.log('Div width:', width);
  // }

  hasSubmenu(menu: MenuItemType): boolean {
    return menu.children ? true : false;
  }

  scrollToActive(): void {
    const activatedItem = document.querySelector('.side-nav-item li a.active');
    if (activatedItem) {
      const simplebarContent = document.querySelector(
        '.sidenav-menu .simplebar-content-wrapper',
      );
      if (simplebarContent) {
        const activatedItemRect = activatedItem.getBoundingClientRect();
        const simplebarContentRect = simplebarContent.getBoundingClientRect();
        const activatedItemOffsetTop =
          activatedItemRect.top + simplebarContent.scrollTop;
        const centerOffset =
          activatedItemOffsetTop -
          simplebarContentRect.top -
          simplebarContent.clientHeight / 2 +
          activatedItemRect.height / 2;
        this.scrollTo(simplebarContent, centerOffset, 600);
      }
    }
  }

  easeInOutQuad(t: number, b: number, c: number, d: number): number {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }

  scrollTo(element: Element, to: number, duration: number): void {
    const start = element.scrollTop;
    const change = to - start;
    const increment = 20;
    let currentTime = 0;

    const animateScroll = () => {
      currentTime += increment;
      const val = this.easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  }

  _activateMenu(): void {
    const div = document.querySelector('.sidenav-menu');

    let matchingMenuItem = null;

    if (div) {
      let items: any = div.getElementsByClassName('nav-link-ref');
      for (let i = 0; i < items.length; ++i) {
        if (
          this.trimmedURL === items[i].pathname ||
          (this.trimmedURL.startsWith('/invoice/') &&
            items[i].pathname === '/invoice/RB6985') ||
          (this.trimmedURL.startsWith('/ecommerce/product/') &&
            items[i].pathname === '/ecommerce/product/1')
        ) {
          matchingMenuItem = items[i];
          break;
        }
      }

      if (matchingMenuItem) {
        const mid = matchingMenuItem.getAttribute('aria-controls');
        const activeMt = findMenuItem(this.menuItems, mid);

        if (activeMt) {
          const matchingObjs = [
            activeMt['key'],
            ...findAllParent(this.menuItems, activeMt),
          ];

          this.activeMenuItems = matchingObjs;
          this.menuItems.forEach((menu: MenuItemType) => {
            menu.collapsed = !matchingObjs.includes(menu.key!);
          });
        }
      }
    }
  }
  onMenuItemClick(key: string): void {
    console.log(key);
    if(key == "azimuth-task-list"){
      this.getCounterAzimut();
    }
    if(key == "arah-task-list"){
      this.getCounterArahPremis();
    }
    if(key == "arah-rumah-task-list"){
      this.getCounterArahRumah();
    }
    this.setActiveMenu(key);

    // Check if on mobile
    if (window.innerWidth <= 768) {
      this.toggleMobileMenu();
    }
  }
  setActiveMenu(key: string): void {
    this.activeMenuItems = [key, ...findAllParent(this.menuItems, { key })];
    this._activateMenu();
  }

  /**
   * toggles open menu
   * @param menuItem clicked menuitem
   * @param collapse collpase instance
   */
  toggleMenuItem(menuItem: MenuItemType, collapse: NgbCollapse): void {
    collapse.toggle();
    let openMenuItems: string[];
    if (!menuItem.collapsed) {
      openMenuItems = [
        menuItem['key'],
        ...findAllParent(this.menuItems, menuItem),
      ];
      this.menuItems.forEach((menu: MenuItemType) => {
        if (!openMenuItems.includes(menu.key!)) {
          menu.collapsed = true;
        }
      });
    }
    // this.toggleMobileMenu()
  }

  changeSidebarSize() {
    let size = document.documentElement.getAttribute('data-sidenav-size')
    if (size == 'sm-hover') {
      size = 'sm-hover-active'
    } else {
      size = 'sm-hover'
    }
    this.store.dispatch(changesidebarsize({ size }))
    this.store.select(getSidebarsize).subscribe((size) => {
      document.documentElement.setAttribute('data-sidenav-size', size)
    })
  }
  toggleMobileMenu() {
    // const sidebarSize = document.documentElement.getAttribute('data-sidenav-size');

    // if (sidebarSize === 'condensed') {
    //   this.store.dispatch(changesidebarsize({ size: 'default' }));
    // } else {
    //   this.store.dispatch(changesidebarsize({ size: 'condensed' }));
    // }
    document.documentElement.classList.toggle('sidebar-enable');
    const backdrop = document.querySelector('.offcanvas-backdrop');
    if (backdrop) {
      backdrop.remove();
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
    this.divWidth = this.currentWidth

  }

}
